import React, { createContext, useMemo, useState, useEffect, useContext } from 'react';
import { getUserProjects, putUserProjects } from '../services/projectDataService';
import { UserContext } from './UserState';

export const ProjectDataContext = createContext(null);

export const ProjectDataProvider = (props) => {
	const [projectData, setProjectData] = useState({});
	const [initialLoading, setInitialLoading] = useState(true);
	const { user } = useContext(UserContext);

	useEffect(() => {
		const fetchData = async () => {
			getUserProjects()
				.then((res) => {
					setProjectData(res.data);
					if (user.isLoggedIn) {
						setInitialLoading(false);
						// if  isNOT user.loggedIn - the whole project can only be fetched. Changes wont be pushed elsewhere.
						// (if logedIN  - all changes to the project will be pushed.)
					}
				})
				.catch((error) => {
					console.error('UserData could not be loaded', { ...error });
				});
		};
		fetchData();
	}, [user.isLoggedIn, user.lastGangHochgeladenGetProjectData]);

	useEffect(() => {
		if (initialLoading || !user.isLoggedIn) {
			// console.log('LoggedOut / or inital Load --> No Data will be pushed');
			return;
		}

		const postData = async () => {
			putUserProjects(projectData)
				.then((res) => {
					console.log('Data pushed! nice');
				})
				.catch((error) => {
					console.error('Data could not be updated!', { ...error });
				});
		};
		postData();
	}, [projectData]);

	const projectDataProviderValue = useMemo(() => ({ projectData, setProjectData }), [
		projectData,
		setProjectData,
	]);

	return (
		<ProjectDataContext.Provider value={projectDataProviderValue}>
			{props.children}
		</ProjectDataContext.Provider>
	);
};
